import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=acf2fc8c"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=acf2fc8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports